import React from 'react'


export default function CustomErrorMsg({ errorMsg, noCenter, verticalPadding }){
    return (
        <p 
            style={{
                textAlign: noCenter ? 'start' : 'center'
            }}
            className={`
                ${verticalPadding && 'py-3'}
                text-red-500 pt-2 text-sm font-weight-500 font-family-poppins
            `}
        >
            {errorMsg}
        </p>
    )
}